<template>
  <div class="windows zeromp">
    <div class="mycontainer zeromp">
      <div class="tile parent-contanier zeromp">
        <div class="tile is-ancestor box is-2 zeromp">
          <sidebar :cargo="this.$route.meta.cargo" />
        </div>

        <div class="tile is-ancestor is-vertical box is-12 zeromp">
          <div class="tile is-parent is-12 zeromp">
            <article class="tile is-child zeromp">
              <div class="content zeromp">
                <internnavbar />
              </div>
            </article>
          </div>
          <div class="tile is-vertical is-12 internbackground">
            <div class="tile is-parent is-vertical">
              <div class="tile is-child">
                <p class="indextitle">Atualizar Teaser</p>
                <div class>
                  <div class id="tabela-Teasers">
                    <section id="teaser-dashboard" class="column">
                      <section id="entity-content">
                        <teaser-form
                          :formtitle="'Cadastrar Novo Teaser'"
                          :teaser="teaser"
                          @formSubmit="CreateTeaser"
                          buttom="Criar Teaser"
                        />
                      </section>
                    </section>
                  </div>
                </div>
              </div>
              <internfooter />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TeaserService from "@/services/TeaserService";
import TeaserForm from "@/components/AdminView/Teaser/Form";
import internnavbar from "@/components/Navbars/InternNav";
import internfooter from "@/components/Footers/InternFooter";
import sidebar from "@/components/SideBar/SideBar";

export default {
  name: "TeaserUpdate",
  props: [],
  methods: {
    CreateTeaser(Teaser) {
      TeaserService.Create(Teaser).then(() => {
        this.$buefy.toast.open({
          duration: 5000,
          message: "Teaser criado com sucesso!",
          position: "is-top-right",
          type: "is-success"
        });
        this.$router.push({ name: "admin/biblioteca/teaser" });
      });
    }
  },
  components: {
    internnavbar: internnavbar,
    internfooter: internfooter,
    sidebar: sidebar,
    TeaserForm: TeaserForm
  },
  data() {
    return {
      Teaser: {
        videos: {
          video_url: null,
          progress: null
        },
        escolas: []
      }
    };
  }
};
</script>